import { render } from "./VideoPlayer.vue?vue&type=template&id=108f43ce&scoped=true&ts=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=108f43ce&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108f43ce"]])

export default __exports__